const pxToRem = (px: number) => `${px / 16}rem`;

export { pxToRem };
